import type { Reducer } from 'redux';
import * as types from './types';
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from 'features/auth/redux/types';
import { Nullable } from 'ts';
import { UserActions } from './actions';
import { User } from 'features/user/ts';

export const INITIAL_STATE = {
  isLoading: false,
  user: null as Nullable<User>,
  error: null as Nullable<string>,
};

const reducer: Reducer<typeof INITIAL_STATE, UserActions> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    case LOGIN_SUCCESS:
      const { user } = action.payload;
      return {
        ...state,
        user,
      };
    case types.PROFILE_REQUEST: {
      const { useLoading } = action.payload;
      return {
        ...state,
        isLoading: useLoading,
        error: null,
      };
    }
    case types.PROFILE_SUCCESS: {
      const { user } = action.payload;
      return {
        ...state,
        isLoading: false,
        user,
      };
    }
    case types.PROFILE_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    case types.CLEAR_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
